const hostedOrigins = new Set(['https://paperzilla.ai', 'https://beta.paperzilla.ai']);

/** Browser-bound OAuth requests must stay with the service that started consent. */
export function resolveMcpOrigin(configuredOrigin: string, browserOrigin?: string): string {
    return browserOrigin && hostedOrigins.has(browserOrigin)
        ? browserOrigin : configuredOrigin.replace(/\/+$/, '');
}
